// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".map-container[data-v-ed8a2a98] {\n  position: relative;\n}\n.search-poi[data-v-ed8a2a98] {\n  position: absolute;\n  left: 20px;\n  top: 20px;\n  z-index: 999;\n  max-width: 300px;\n}\n[data-v-ed8a2a98].el-popper {\n  width: 300px !important;\n}", ""]);
// Exports
module.exports = exports;
